/**
 * SERVICE_PROVIDERS
 */
import { BasicEntityService } from './basic-entity';

import { OrdersService } from './orders';
import { HomeService } from './home';
import { VendorService } from './vendor';
import { InventoryItemVenueService } from './inventory-item-venue';
import { SitesService } from './sites';
import { TransferService } from './transfer';
import { StandWorksheetService } from './stand-worksheet';
import { RecipeVenueService } from './recipe-venue';
import { ProductService } from './product';
import {
  InventoryCountGroupService,
  InventoryCountService,
} from '@shared/services/inventory-count';
import { TagService } from '@shared/services/tag';
import { EventsService } from '@shared/services/events';
import { EventTypeService } from './event-type';
import { HistoricalQuantitiesService } from './historical-quantities';
import { IncompleteTransferService } from './incomplete-transfer';
import { TransferDestinationsService } from './transfer-destinations';
import { CurrencySchemeService } from './currency-scheme/currency-scheme.service';
import { TransferAutoRestockService } from './transfer-auto-restock/transfer-auto-restock.service';
import { TransferGroupService } from './transfer-group';
import { TransferGroupAutoRestockService } from './transfer-group-auto-restock';
import { AuditTrailService } from './audit-trail/audit-trail.service';
import { TransferGroupTemplateService } from './transfer-group-template';
import { CartService } from './cart';
import { FilteredOrderService } from './filtered-order/filtered-order.service';
import { FilteredTransferService } from './filtered-transfer/filtered-transfer.service';
import { TransferRequestService } from './transfer-request/transfer-request.service';
import { HawkerProfileService } from './hawker-profile';
import { XdmCommissionRateService } from './xdm-commission-rate/xdm-commission-rate.service';
import { HawkerLoadService } from './hawker-load';
import { HawkerCommissaryAssignmentService } from './hawker-commissary-assignment';
import { HawkerSessionService } from './hawker-session';
import { HawkerCommissaryAssignmentHistoryService } from './hawker-commissary-assignment-history';
import { HawkerSessionAdminService } from './hawker-session-admin';

export const BASE_ENTITY_SERVICES: any[] = [
  OrdersService,
  VendorService,
  InventoryItemVenueService,
  HomeService,
  BasicEntityService,
  EventsService,
  SitesService,
  TransferService,
  TransferDestinationsService,
  StandWorksheetService,
  RecipeVenueService,
  ProductService,
  InventoryCountGroupService,
  InventoryCountService,
  TagService,
  EventTypeService,
  CartService,
  HistoricalQuantitiesService,
  IncompleteTransferService,
  CurrencySchemeService,
  TransferAutoRestockService,
  TransferGroupService,
  TransferGroupAutoRestockService,
  AuditTrailService,
  TransferGroupTemplateService,
  FilteredOrderService,
  FilteredTransferService,
  TransferRequestService,
  HawkerProfileService,
  XdmCommissionRateService,
  HawkerLoadService,
  HawkerCommissaryAssignmentService,
  HawkerSessionService,
  HawkerCommissaryAssignmentHistoryService,
  HawkerSessionAdminService,
];

export const ENTITY_SERVICES: any[] = [...BASE_ENTITY_SERVICES];
